import { LockOutlined } from "@mui/icons-material";
import {
  Container,
  CssBaseline,
  Box,
  Avatar,
  Typography,
  TextField,
  Button,
  Divider,
  Grid,
} from "@mui/material";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { useAppDispatch } from "../hooks/redux-hooks";
import { login } from "../slices/authSlice";
import {
  showNotification,
  NotificationType,
} from "../slices/notificationSlice";
import { useTranslation } from "react-i18next";
import * as consts from "../constants";

import { Link as RouterLink } from "react-router-dom";
import { Link as MuiLink } from "@mui/material";

const Login = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  useEffect(() => {
    localStorage.removeItem("driverInfo");
    localStorage.removeItem("isDriver");
  }, []);

  const handleLogin = async () => {
    setEmailError("");
    setPasswordError("");

    if (!email) {
      setEmailError(t("errEmailRequired"));
      return;
    }
    if (!password) {
      setPasswordError(t("pleaseInputPassword"));
      return;
    }

    dispatch(
      login({
        email,
        password,
        type: consts.customerType.EMAIL,
      })
    );
  };

  const handleLoginAsGuest = async () => {
    dispatch(
      login({
        key: "tmp",
        type: consts.customerType.GUEST,
      })
    );
  };

  const handleGoogleSuccess = async (credentialResponse: any) => {
    try {
      // console.log(credentialResponse.credential);
      const result = await dispatch(
        login({
          credential: credentialResponse.credential,
          type: consts.customerType.GOOGLE,
        })
      );
      if (login.fulfilled.match(result)) {
        // 登录成功处理
        console.log("login as google success");
      }
    } catch (error) {
      dispatch(
        showNotification({
          message: t("googleSigninFailed"),
          type: NotificationType.Error,
        })
      );
    }
  };

  return (
    <>
      <Container maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            mt: 5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: "primary.light" }}>
            <LockOutlined />
          </Avatar>
          <Typography variant="h5">{t("login")}</Typography>
          <Box sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label={t("emailAddress")}
              name="email"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={!!emailError}
              helperText={emailError}
            />

            <TextField
              margin="normal"
              required
              fullWidth
              id="password"
              name="password"
              label={t("password")}
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              error={!!passwordError}
              helperText={passwordError}
            />
            {/* 添加忘记密码链接 */}
            <Grid container justifyContent="flex-end">
              <Grid item>
                <MuiLink
                  component={RouterLink}
                  to="/forgot-password"
                  sx={{
                    textDecoration: "none",
                    "&:hover": {
                      textDecoration: "underline",
                    },
                  }}
                >
                  {t("forgotPassword")}
                </MuiLink>
              </Grid>
            </Grid>
            <Button
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={handleLogin}
            >
              {t("login")}
            </Button>
            {/* <Button
              fullWidth
              variant="contained"
              //sx={{ mt: 3, mb: 2 }}
              onClick={handleLoginAsGuest}
            >
              {t("btnLoginAsGuest")}
            </Button> */}
            <Divider>or</Divider>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {/* <Button
                type="submit"
                fullWidth
                variant="outlined"
                onClick={() => alert("Sign in with Google")}
                startIcon={<GoogleIcon />}
              >
                Sign in with Google
              </Button> */}
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={() => {
                  dispatch(
                    showNotification({
                      message: t("errGoogleSigninFailed"),
                      type: NotificationType.Error,
                    })
                  );
                }}
                useOneTap
                type="standard"
                theme="filled_blue"
                size="large"
                text="signin_with"
                shape="rectangular"
              />
            </Box>
            <Grid container justifyContent={"flex-end"}>
              <Grid item>
                <Link to="/register">{t("gotoRegister")}</Link>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default Login;
